module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }